{
  "en": {
    "imagePicker": {
      "addButton": "Add image",
      "title": "Add image",
      "replaceTitle": "Replace image",
      "replaceButton": "Replace image",
      "backgroundPreviewAlt": "Current background image",
      "searchPlaceholder": "Search images...",
      "tabLabelWithCount": "{label} ({count})",
      "resultCount": "No results | {count} result | {count} results",
      "resultCountCapped": "More than {count} results",
      "cancel": "Cancel",
      "confirm": "Use",
      "empty": {
        "headline": "No results for \"{query}\" here",
        "subline": "Try a different search term"
      },
      "error": {
        "headline": "The images could not be loaded.",
        "retry": "Try again"
      },
      "generate": {
        "tabLabel": "Generate Image",
        "headline": "Create an image",
        "promptPlaceholder": "Describe your image",
        "cta": "Create image",
        "ctaRegenerate": "Regenerate image",
        "generating": "Image is being created",
        "generated": "Image created and selected",
        "resultSelect": "Select generated image",
        "modelLabel": "Select AI model",
        "uploadError": "The image could not be applied. Please try again.",
        "limitReached": "You have reached your daily limit for AI images."
      },
      "upload": {
        "tabLabel": "Upload",
        "dropTitle": "Drag & drop here or {select}.",
        "dropTitleSelect": "Select image",
        "success": "File uploaded successfully",
        "remove": "Remove image",
        "errors": {
          "wrongFormat": "This file format is not supported. Allowed formats: {formats}",
          "failed": "The image could not be uploaded. Please try again."
        }
      },
      "stock": {
        "tabLabel": "Royalty-free images",
        "source": "Source:",
        "imageTypeLegend": "Image type",
        "categoryLimit": "Maximum of {max} categories at the same time.",
        "uploadError": "The image could not be applied. Please try again.",
        "categories": {
          "nature": "Nature",
          "animals": "Animals",
          "research": "Research",
          "mathematics": "Mathematics",
          "technology": "Technology",
          "reading": "Reading",
          "creativity": "Creativity",
          "music": "Music",
          "sports": "Sports",
          "nutrition": "Nutrition",
          "classroom": "Classroom",
          "teamwork": "Teamwork",
          "climate": "Climate",
          "space": "Space",
          "summer": "Summer",
          "spring": "Spring",
          "autumn": "Autumn",
          "winter": "Winter",
          "easter": "Easter",
          "christmas": "Christmas"
        }
      },
      "library": {
        "tabLabel": "My Files",
        "selectError": "The image could not be saved. Please try again.",
        "imageAlt": {
          "manual": "Uploaded Image",
          "ai": "AI-generated Image"
        },
        "empty": {
          "headline": "You don't have any images yet",
          "subline": "Your uploaded and AI-generated images will appear here."
        }
      }
    }
  }
}
